(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lbs-style-inspiration-horizon"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const TAG = 'lbs-style-inspiration';

    if (customElements.get(TAG)) return;

    class LbsStyleInspiration extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.hotspotButtons = Array.from(this.querySelectorAll('[data-hotspot-button]'));
        this.closeButtons = Array.from(this.querySelectorAll('[data-hotspot-close]'));
        this.track = this.querySelector('[data-carousel-track]');
        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');

        this.onHotspotClick = (event) => {
          const button = event.currentTarget;
          const popoverId = button.getAttribute('aria-controls');
          const popover = popoverId ? this.querySelector(`#${CSS.escape(popoverId)}`) : null;

          if (!popover) return;

          const shouldOpen = button.getAttribute('aria-expanded') !== 'true';

          this.closeAllPopovers(button);

          if (shouldOpen) {
            popover.hidden = false;
            button.setAttribute('aria-expanded', 'true');
          }
        };

        this.onCloseClick = (event) => {
          const popover = event.currentTarget.closest('[data-hotspot-popover]');
          if (!popover) return;

          const button = this.querySelector(`[aria-controls="${popover.id}"]`);
          popover.hidden = true;
          button?.setAttribute('aria-expanded', 'false');
          button?.focus();
        };

        this.onDocumentPointerDown = (event) => {
          if (this.contains(event.target)) {
            const insidePopover = event.target.closest?.('[data-hotspot-popover]');
            const hotspotButton = event.target.closest?.('[data-hotspot-button]');

            if (insidePopover || hotspotButton) return;
          }

          this.closeAllPopovers();
        };

        this.onDocumentKeyDown = (event) => {
          if (event.key !== 'Escape') return;

          const openButton = this.querySelector('[data-hotspot-button][aria-expanded="true"]');

          if (openButton) {
            this.closeAllPopovers();
            openButton.focus();
          }
        };

        this.onPrev = () => {
          this.scrollCarousel(-1);
        };

        this.onNext = () => {
          this.scrollCarousel(1);
        };

        this.onScroll = () => {
          window.requestAnimationFrame(() => this.updateCarouselControls());
        };

        this.hotspotButtons.forEach((button) => {
          button.addEventListener('click', this.onHotspotClick);
        });

        this.closeButtons.forEach((button) => {
          button.addEventListener('click', this.onCloseClick);
        });

        document.addEventListener('pointerdown', this.onDocumentPointerDown);
        document.addEventListener('keydown', this.onDocumentKeyDown);

        this.prevButton?.addEventListener('click', this.onPrev);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track?.addEventListener('scroll', this.onScroll, { passive: true });

        this.onBlockSelect = (event) => {
          const card = event.target?.closest?.('[data-look-card]');
          if (!card || !this.contains(card)) return;

          card.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center',
          });
        };

        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.updateCarouselControls();
      }

      disconnectedCallback() {
        this.hotspotButtons?.forEach((button) => {
          button.removeEventListener('click', this.onHotspotClick);
        });

        this.closeButtons?.forEach((button) => {
          button.removeEventListener('click', this.onCloseClick);
        });

        document.removeEventListener('pointerdown', this.onDocumentPointerDown);
        document.removeEventListener('keydown', this.onDocumentKeyDown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);

        this.prevButton?.removeEventListener('click', this.onPrev);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
      }

      closeAllPopovers(exceptButton = null) {
        this.hotspotButtons?.forEach((button) => {
          if (button === exceptButton) return;

          const popoverId = button.getAttribute('aria-controls');
          const popover = popoverId ? this.querySelector(`#${CSS.escape(popoverId)}`) : null;

          button.setAttribute('aria-expanded', 'false');

          if (popover) {
            popover.hidden = true;
          }
        });
      }

      scrollCarousel(direction) {
        if (!this.track) return;

        const firstCard = this.track.querySelector('[data-look-card]');
        if (!firstCard) return;

        const styles = window.getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || 0);
        const amount = firstCard.getBoundingClientRect().width + gap;

        this.track.scrollBy({
          left: direction * amount,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }

      updateCarouselControls() {
        if (!this.track || !this.prevButton || !this.nextButton) return;

        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const current = Math.max(0, this.track.scrollLeft);

        this.prevButton.disabled = current <= 2;
        this.nextButton.disabled = current >= maxScroll - 2;
      }
    }

    customElements.define(TAG, LbsStyleInspiration);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
